import { ChannelkartNetworkGet, ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";

export async function uploadMetadata(requestBody: any) {
    const response = await ChannelkartNetworkPost(`/metadata`, requestBody);
    return response.data;
}

export async function getMetadata(){
    const response = await ChannelkartNetworkGet(`/metadata/BusinessCalendar?name=fieldWiseHolidayCalender`);
    return response.data;
}

export async function updateMetadata(requestBody :any){
    const response = await ChannelkartNetworkPut(`/metadata/BusinessCalendar?name=fieldWiseHolidayCalender`, requestBody);
    return response.data;
}